import { getDuizhangdan, updateDuizhangdan, deleteDuizhangdan, createDuizhangdan } from '@/api/duizhangdan'
import Vue from 'vue'

const state = {
  duizhangdanList: [],
  totalCounts: 0,
}

const actions = {
  async getDuizhangdanAction({ commit }, payload) {
    try {
      const duizhangdanList = await getDuizhangdan(payload);
        commit('SET_DUIZHANGDAN_LIST', duizhangdanList.data)
        return duizhangdanList.data
    } catch (error) {
      throw error.message
    }
  },
  async getDuizhangdanByIDAction({ commit }, payload) {
    try {
      const duizhangdan = await getDuizhangdanByID(payload)
      return duizhangdan.data
    } catch (error) {
      throw error.message
    }
  },
  async createDuizhangdanAction({ commit }, payload) {
    try {
      const duizhangdan = await createDuizhangdan(payload);
      commit('ADD_DUIZHANGDAN', duizhangdan.data)
      return duizhangdan.data
    } catch (error) {
      throw error.message
    }
  },
  async updateDuizhangdanAction({ commit }, payload) {
    try {
      const duizhangdan = await updateDuizhangdan(payload.id, payload.data)
      commit('UPDATE_DUIZHANGDAN', duizhangdan.data)
      return duizhangdan.data
    } catch (error) {
      throw error.message
    }
  },
  async deleteDuizhangdanAction({ commit }, payload) {
    try {
      await deleteDuizhangdan(payload)
      commit('DELETE_DUIZHANGDAN', payload)
    } catch (error) {
      throw error.message
    }
  }
}

const mutations = {
  SET_DUIZHANGDAN_LIST(state, payload) {
    state.duizhangdanList = payload.list;
    state.totalCounts = payload.totalCounts
  },
  ADD_DUIZHANGDAN(state, duizhangdan) {
    state.duizhangdanList.unshift(duizhangdan)
    state.totalCounts++
  },
  DELETE_DUIZHANGDAN(state, id) {
    state.duizhangdanList = state.duizhangdanList.filter(e => e._id !== id)
    state.totalCounts--
  },
  UPDATE_DUIZHANGDAN(state, duizhangdan) {
    Vue.set(state.duizhangdanList, state.duizhangdanList.findIndex(x => x._id === duizhangdan._id), duizhangdan)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}